import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function transporter() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`transporter/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`transporter/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('transporter/create', data);
    }

    function update(data) {
        return axiosInstance.patch('transporter/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`transporter/delete`, {
            data: {
                id: id
            }
        });
    }
}
